import {skipToken} from '@reduxjs/toolkit/query';

import {useSelector} from 'react-redux';

import {useGetParticipationQuery} from '@dms/api/core';
import {selectActiveBranchId} from '@dms/api/features';
import {EntityResourceIds} from '@dms/api/shared';
import {useGetSaleVehicleQuery} from '@dms/api/vehicle';
import {usePermissions} from '@dms/shared';

export function useCanReadVehicleAdvertisingSettings(vehicleId?: string): boolean {
  const activeBranchId = useSelector(selectActiveBranchId);
  const {data: vehicleParticipation} = useGetParticipationQuery(
    vehicleId
      ? {
          resourceId: EntityResourceIds.vehicle,
          recordId: vehicleId,
        }
      : skipToken
  );
  const {data: saleVehicle} = useGetSaleVehicleQuery(vehicleId ? {vehicleId} : skipToken);
  const [canReadAdvertisingSettings] = usePermissions({
    permissionKeys: ['readAdvertisingSettings'],
    scopes: {
      readAdvertisingSettings: {
        participation: vehicleId ? vehicleParticipation : 'SKIP',
        branchId: vehicleId ? saleVehicle?.branchId : activeBranchId,
      },
    },
  });

  return canReadAdvertisingSettings;
}
